import React from "react";
import { useUserContext } from "context/UserContext";
import KeyMetricsBK from "layouts/BK/keyMetrics";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";

function KeyMetrics() {
  const { roleLevel } = useUserContext() || {};
  if (isManagementRoleLevel(normalizeRoleLevel(roleLevel))) {
    return <KeyMetricsBK />;
  }
  return null;
}

export default KeyMetrics;
